import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../../components/kiene-table/kiene-table.service';
import { Verkaufspreis } from '../../../../components/verkaufspreis-selector/verkaufspreis-selector.component';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Material } from '../../../../warehouse/material/material';
import { PreisgruppeArtikel } from '../../preisgruppen';

@Component({
    selector: 'kiene-add-preisgruppe-artikel',
    templateUrl: './add-preisgruppe-artikel.component.html',
    styleUrls: ['./add-preisgruppe-artikel.component.scss'],
})
export class AddPreisgruppeArtikelComponent implements OnInit {
    preisgruppeArtikel: PreisgruppeArtikel;
    artikel: Material = new Material();
    verkaufspreis: Verkaufspreis = new Verkaufspreis();

    constructor(
        public dialogRef: MatDialogRef<AddPreisgruppeArtikelComponent>,
        public api: KieneTableService,
        public messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        if (data.preisgruppeArtikel !== null && data.preisgruppeArtikel !== undefined) {
            this.preisgruppeArtikel = data.preisgruppeArtikel;
            this.artikel.artikel_id = this.preisgruppeArtikel.artikel_id;
            this.artikel.artikel_me = this.preisgruppeArtikel.artikel;
            this.verkaufspreis.verkaufspreis_id = this.preisgruppeArtikel.verkaufspreis_id;
            this.verkaufspreis.bezeichnung = this.preisgruppeArtikel.verkaufspreis;
        } else {
            this.preisgruppeArtikel = new PreisgruppeArtikel();
            this.preisgruppeArtikel.preisgruppe_id = data.preisgruppe_id;
        }
    }

    ngOnInit() {}

    cancel() {
        this.dialogRef.close();
    }

    save() {
        if (this.artikel !== null && this.artikel.artikel_id !== null) {
            this.preisgruppeArtikel.artikel_id = this.artikel.artikel_id;

            if (this.verkaufspreis !== null && this.verkaufspreis.verkaufspreis_id !== null) {
                this.preisgruppeArtikel.verkaufspreis_id = this.verkaufspreis.verkaufspreis_id;
            } else {
                this.preisgruppeArtikel.verkaufspreis_id = null;
            }

            this.api
                .updateEntity(this.apiBaseUrl + 'preisgruppe_artikel/update.php', this.preisgruppeArtikel)
                .subscribe(
                    () => {
                        this.cancel();
                    },
                    error => {
                        this.messageService.errorMessage('Preisgruppenartikel konnte nicht gespeichert werden!', error);
                    },
                );
        } else {
            this.messageService.errorMessage('Keinen Artikel ausgewählt!', null);
        }
    }

    setArtikel(artikel: Material) {
        this.artikel = artikel;
    }

    setVerkaufspreis(verkaufspreis: Verkaufspreis) {
        this.verkaufspreis = verkaufspreis;
    }
}
